import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import {Spin } from 'antd';
import RepositorySelectorAdd from './repository_selector_add';
import { showErrorInNotification } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';

class RepositorySelectorEdit extends Component {
    constructor(props) {
      super(props)
    
      this.repository_id=props.match.params.repository_id;
      this.selector_id=props.match.params.selector_id;

      this.state = {
         loading:true,
         edit_data:{}
      };

      this.get_detail=RESTExecutor.detail().config({
          label:'selectors_detail',
          params:{
              repository_id:this.repository_id,
              selector_id:this.selector_id
          }
      }).callbacks((success)=>{
          this.setState({
              edit_data:success.result,
              loading:false
          })
      },(error)=>{
        showErrorInNotification(error);
        this.setState({
          loading:false
        })
      }).connect(props.domains.datarepository);
      this.get_detail.execute()

    };
    
  render() {
      if(this.state.loading){
          return <center><Spin/></center>
      }
      let get_detail_resp=this.get_detail.response();
    return (
        <ErrorWrapper
        error={get_detail_resp}
        onReload={()=>{
          this.setState({
            loading:true
          });
          this.get_detail.execute()
        }}
        >
      <RepositorySelectorAdd 
      key={`${this.state.edit_data&&this.state.edit_data.id}--`}
      edit_id={this.state.edit_data&&this.state.edit_data.id}
      edit_data={this.state.edit_data}
      match={{
        params:{
          repository_id:this.repository_id
        }
      }}
      />
      </ErrorWrapper>
    );
  }
}

export default withDomains(RepositorySelectorEdit,"datarepository");
